import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartslice'; // Import the cart slice reducer
import orderReducer from './orderSlice';
import wishlistReducer from './wishlistslice';
import loginReducer from './loginSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage or sessionStorage

// Redux Persist configuration
const CartpersistConfig = {
    key: 'cart',
    storage, // You can use sessionStorage instead of localStorage if you prefer
};
// Redux Persist configuration
const OrderpersistConfig = {
    key: 'order',
    storage, // You can use sessionStorage instead of localStorage if you prefer
};
// Redux Persist configuration
const WishlistpersistConfig = {
    key: 'wishlist',
    storage, // You can use sessionStorage instead of localStorage if you prefer
};
// Redux Persist configuration
const LoginpersistConfig = {
    key: 'login',
    storage, // You can use sessionStorage instead of localStorage if you prefer
};

// Wrap your cart reducer with persistReducer
const persistedCartReducer = persistReducer(CartpersistConfig, cartReducer);
// Wrap your Orde reducer with persistReducer
const persistedOrdeReducer = persistReducer(OrderpersistConfig, orderReducer);
// Wrap your Orde reducer with persistReducer
const persistedWishlistReducer = persistReducer(WishlistpersistConfig,wishlistReducer);
// Wrap your Orde reducer with persistReducer
const persistedLoginReducer = persistReducer(LoginpersistConfig,loginReducer);


const store = configureStore({
    reducer: {
        cart: persistedCartReducer,  // Add the cart reducer to the store
        order:persistedOrdeReducer, //Add the order Reducer to the store
        wishlist : persistedWishlistReducer,//Add the Wishlist reducer to the store 
        login : persistedLoginReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: {
            ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
          },
        }),
});

// export default store;
// Create persistor
const persistor = persistStore(store);

export { store, persistor };